function Header() {
  return (
    <section className="more_padding_up">
      <div className="left_section">
        <span className="section_title">
          Explore, Mint, and Own Peculiar{" "}
          <span className="green_text">Funkies</span> Collectibles
        </span>
        <span className="section_text">
          Limited 10,000 unique pixelated funkies.
        </span>
        {/* is live. 0.02ETH per funky */}
        <span className="edged_button">Minting is coming soon</span>
        <br />
        &nbsp; &nbsp; &nbsp;
        <div>
          <a
            href="https://discord.gg/p4vyXHNWzd"
            target="blank"
            className="nav_link button_type free_button"
          >
            DISCORD
          </a>
          <a
            href="https://twitter.com/FunkiesC"
            target="blank"
            className="nav_link button_type free_button"
          >
            Twitter
          </a>
          <a
            href="https://t.me/+A6bWd0_BIiY0YjU0"
            target="blank"
            className="nav_link button_type free_button"
          >
            Telegram
          </a>
        </div>
      </div>
      <div className="right_section">
        <img src="img/m10.svg" alt="" className="right_box" />
      </div>
    </section>
  );
}

export default Header;
